import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonUsecaseService {

  headerSearchText: BehaviorSubject<string> = new BehaviorSubject<string>('');
  constructor() { }


  calculateAgeFromDOB(dob: string) {
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    // adjust if birthday hasn’t occurred yet this year
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }
  // Function to allow only alphabets and specific control keys
  allowOnlyNumbers(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End'];
    if (!/[0-9]/.test(event.key) && !allowedKeys.includes(event.key) && !(event.ctrlKey && ['a', 'c', 'v', 'A', 'C', 'V'].includes(event.key))) {
      event.preventDefault();
    }
  }

  // Function to allow only alphabets and specific control keys
  allowOnlyAlphabets(event: KeyboardEvent) {
  const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End', ' '];
    if (!/^[a-zA-Z]$/.test(event.key) && !allowedKeys.includes(event.key) && !(event.ctrlKey && ['a', 'c', 'v', 'A', 'C', 'V'].includes(event.key))) {
      event.preventDefault();
    }
  }

  // Function to allow only alphabets, numbers and specific control keys
  allowAlphabetsAndNumbers(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End', ' '];
    if (!/^[a-zA-Z0-9]$/.test(event.key) && !allowedKeys.includes(event.key) && !(event.ctrlKey && ['a', 'c', 'v', 'A', 'C', 'V'].includes(event.key))) {
      event.preventDefault();
    }
  }

  capitalizeFirst(str: string): string {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }
}
